"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("@containers/common/model"));
const model_2 = __importDefault(require("@containers/DF0001/model"));
// import pmsu01 from '@containers/PMSU01/model';
const redux_1 = require("redux");
const appReducer = (0, redux_1.combineReducers)({
    common: model_1.default,
    df0001: model_2.default
});
const rootReducer = (state, action) => {
    switch (action.type) {
        case 'LOGOUT': {
            return appReducer(undefined, action);
        }
        default:
            return appReducer(state, action);
    }
};
exports.default = rootReducer;
